<template>
  <v-dialog v-bind="$attrs" v-on="$listeners" :value="value" @input="onInput">
    <template v-slot:default="{ attrs, on }">
      <slot v-bind="{ attrs, on }"></slot>
    </template>
    <template v-slot:activator="{ attrs, on }">
      <slot name="activator" v-bind="{ attrs, on }"></slot>
    </template>
  </v-dialog>
</template>

<script>
import uuid4 from '@/utils/uuid.js';

export default {
  name: 'dialog-scroll-lock',

  props: [ 'value' ],

  created() {
    this.uuid = uuid4();
    this.$set(this.global.scrollLock, this.uuid, Boolean(this.value));
  },

  destroyed() {
    this.$delete(this.global.scrollLock, this.uuid);
  },

  methods: {
    onInput(v) {
      this.$set(this.global.scrollLock, this.uuid, v);
      this.$emit('input', v);
    }
  }
}
</script>
